<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.LCLDestinationPortChargesDetails')"
    width="650px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view pod-charge-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.Source')">
                <cargo-advance-select
                  no="bookingAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{bookingAgent:true,active:true}"
                  tag-name="chineseName"
                  :default-value="price.bookingAgent"
                  @parentCallBack="p=>{price.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.TradeLane')">
                <cargo-advance-select
                  no="tradeLane"
                  :select-type="selectTypeNames.basic_data_Region"
                  :custom-label="(item)=>`${item.name}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.tradeLane"
                  filterable
                  @parentCallBack="p=>{price.tradeLane=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true, active: true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.FeeIndex')">
                <el-input
                  v-model="price.feeIndex"
                  no="feeIndex"
                  :maxlength="10"
                />
              </el-form-item>
              <el-form-item ref="chargeScaleCode" required :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.FeeName')">
                <cargo-advance-select
                  no="chargeScaleCode"
                  filterable
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  callback-method-type="value"
                  tag-name="zhName"
                  tag-value="scaleCode"
                  :default-value="price.chargeScaleCode"
                  @parentCallBack="changeSurchargeScaleCode"
                />
              </el-form-item>
              <el-form-item ref="chargeType" required :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.ChargeType')">
                <cargo-advance-select
                  no="chargeType"
                  :static-options="chargeTypes"
                  tag-name="label"
                  :clearable="false"
                  tag-value="value"
                  :default-value="price.chargeType"
                  @parentCallBack="p=>{price.chargeType=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ChargeUnit')">
                <cargo-advance-select
                  no="unit"
                  filterable
                  :clearable="false"
                  :select-type="selectTypeNames.basic_data_ChargeUnit"
                  callback-method-type="value"
                  tag-name="chineseName"
                  tag-value="code"
                  :default-value="price.unit"
                  @parentCallBack="p=>{price.unit=p}"
                />
              </el-form-item>
              <el-form-item ref="payment" required :valid="$t('Pricing.PlsSelect')" :label="$t('Pricing.PaymentTerm')">
                <cargo-advance-select
                  no="payment"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PAYMENT_TERMS"
                  :show-custom-label-in-option="true"
                  :clearable="false"
                  :default-value="price.payment"
                  @parentCallBack="p=>{price.payment=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="price.vat">{{ $t('Pricing.VatIncluded') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('Pricing.COST_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="costVat"
                    no="costVat"
                    type="number"
                    style="width: 100%"
                    @change="costVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.SELL_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="sellVat"
                    no="sellVat"
                    type="number"
                    style="width: 100%"
                    @change="sellVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.GenerateCharge')">
                <el-checkbox v-model="price.generateCharge" no="generateCharge" />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="currency" required :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Cost')">
                <span slot="label" style="display: block;">
                  <span style="width:50%; display: inline-block;">
                    {{ $t('Pricing.Cost') }}
                  </span>
                  <span>
                    Min
                  </span>
                </span>
                <numeric-stepper
                  no="costMin"
                  style="margin-bottom: 3px;"
                  :show-tact="false"
                  :show-value="price.costMin"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.costMin=p}"
                />
                <span slot="label" style="margin-top: 10px">
                  <span style="width:50%; display: inline-block;" />
                  <span>
                    Rate
                  </span>
                </span>
                <numeric-stepper
                  no="costRate"
                  :show-tact="false"
                  :show-value="price.costRate"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.costRate=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Coloader')">
                <span slot="label" style="display: block;">
                  <span style="width:50%; display: inline-block;">
                    {{ $t('Pricing.Coloader') }}
                  </span>
                  <span>
                    Min
                  </span>
                </span>
                <numeric-stepper
                  no="coloaderMin"
                  style="margin-bottom: 3px;"
                  :show-tact="false"
                  :show-value="price.coloaderMin"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.coloaderMin=p}"
                />
                <span slot="label" style="margin-top: 10px">
                  <span style="width:50%; display: inline-block;" />
                  <span>
                    Rate
                  </span>
                </span>
                <numeric-stepper
                  no="coloaderRate"
                  :show-tact="false"
                  :show-value="price.coloaderRate"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.coloaderRate=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.DirectCustomer')">
                <span slot="label" style="display: block;">
                  <span style="width:50%; display: inline-block;">
                    {{ $t('Pricing.DirectCustomer') }}
                  </span>
                  <span>
                    Min
                  </span>
                </span>
                <numeric-stepper
                  no="customerMin"
                  style="margin-bottom: 3px;"
                  :show-tact="false"
                  :show-value="price.customerMin"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.customerMin=p}"
                />
                <span slot="label" style="margin-top: 10px">
                  <span style="width:50%; display: inline-block;" />
                  <span>
                    Rate
                  </span>
                </span>
                <numeric-stepper
                  no="customerRate"
                  :show-tact="false"
                  :show-value="price.customerRate"
                  :nil-label="$t('Price.Empty')"
                  @onChangeValue="p=>{price.customerRate=p}"
                />
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <el-input
                  v-model="price.remarks"
                  no="remarks"
                  type="textarea"
                  :maxlength="255"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { savePodCharge } from '@/api/price/podCharge'
import { getLoading } from '@/utils/utilBaseElement'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import RateGrade from '@/views/cargo/v0/Price/components/rateGrade'
import { ChargeItem } from '@/class/model/mdm/chargeItem'

export default {
  name: 'PodChargeForm',
  components: { RateGrade, NumericStepper, CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      chargeTypes: [], // 费用类型数据来源
      costVat: null,
      sellVat: null,
      fullscreenLoading: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isFrequency() {
      return this.setFrequency('frequency')
    }
  },
  mounted() {
    // 加载费用类型
    this.$nextTick(() => {
      this.onSurchargeScaleCodeChanged()
      this.sellVatChange(this.price.sellVat)
      this.costVatChange(this.price.costVat)
    })
  },
  methods: {
    onSubmit() {
      if (this.verifyForm()) {
        return
      }
      if (
        (StrUtils.isEmpty(this.price.bookingAgent) || this.price.bookingAgent === -99) &&
        StrUtils.isEmpty(this.price.pol) &&
        StrUtils.isEmpty(this.price.pod) &&
        StrUtils.isEmpty(this.price.tradeLane) &&
        StrUtils.isEmpty(this.price.carrier)) {
        this.$message.warning(this.$t('Pricing.RouteAndPODEmpty1'))
        return
      }
      if (!this.price.vat) {
        if (this.price.sellVat < this.price.costVat) {
          this.$message.warning(this.$t('Pricing.VatInvalid'))
          return
        }
      } else {
        this.price.costVat = 0
        this.price.sellVat = 0
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      if (StrUtils.isEmpty(this.price.bookingAgent)) {
        this.price.bookingAgent = -99
      }
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.save()
    },
    save() {
      this.fullscreenLoading = getLoading()
      let changeState = false
      if (!this.isNew && this.price.state === 1) {
        this.price.state = 0
        changeState = true
      }
      savePodCharge(this.price).then((res) => {
        this.fullscreenLoading.close()
        if (res.data) {
          if (!changeState) {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          }
          this.$emit('reload')
        } else {
          this.$message.success(this.$t('Message.SaveFailed'))
        }
        this.$emit('close')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          this.$refs[ref].$el.getElementsByTagName('input')[0].focus()
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0
      }
      return StrUtils.isEmpty(this.price[field])
    },
    onCancel() {
      this.$emit('close')
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    setFrequency(targetField) {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price[targetField + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    },
    changeSurchargeScaleCode(p) {
      this.price.chargeScaleCode = p
      this.onSurchargeScaleCodeChanged()
    },
    async onSurchargeScaleCodeChanged() {
      if (this.price.chargeScaleCode) {
        const chargeItem = await ChargeItem.getChargeItemByScaleCode(this.price.chargeScaleCode)
        const source = []
        if (chargeItem) {
          if (chargeItem.surcharge) {
            source.push({ 'label': this.$t('Pricing.Surcharge'), 'value': 'S' })
          }
          if (chargeItem.localCharge) {
            source.push({ 'label': this.$t('Pricing.LocalCharge'), 'value': 'L' })
          }
          if (chargeItem.desCharge) {
            source.push({ 'label': this.$t('Pricing.DesCharge'), 'value': 'D' })
          }
        } else {
          source.push({ 'label': this.$t('Pricing.Surcharge'), 'value': 'S' })
          source.push({ 'label': this.$t('Pricing.LocalCharge'), 'value': 'L' })
          source.push({ 'label': this.$t('Pricing.DesCharge'), 'value': 'D' })
        }
        this.chargeTypes = source
        if (source.length === 1) {
          this.price.chargeType = source[0].value
        }
      } else {
        this.chargeTypes = []
      }
    },
    costVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.costVat = null
        this.price.costVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.costVat = formatNumber
      this.costVat = formatNumber
    },
    sellVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.sellVat = null
        this.price.sellVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.sellVat = formatNumber
      this.sellVat = formatNumber
    }
  }
}
</script>

<style lang="scss">
  .pod-charge-form{
    .el-textarea__inner{
      min-height: 100px !important;
    }
    input[type="number"]{
      text-align: right;
    }
  }
</style>
